import styled from '@emotion/styled'
import axios from 'axios'
import { motion } from 'framer-motion'
import lottie, { AnimationItem } from 'lottie-web'
import { useCallback, useEffect, useRef, useState } from 'react'

import alarmClockMp3 from '@/assets/mp3/alarmClock.mp3'
import courseRightMp3 from '@/assets/mp3/courseRight.mp3'
import flowerMp3 from '@/assets/mp3/flower.mp3'
import praiseMp3 from '@/assets/mp3/praise.mp3'
import sunMp3 from '@/assets/mp3/sun.mp3'
import willEndMp3 from '@/assets/mp3/willEnd.mp3'

import { roomEvent } from '../..'
import { RewardType } from '../Tools'

export type AudioType = Record<RewardType, HTMLAudioElement | null>

export default function Index() {
  const lottieRef = useRef<HTMLDivElement>(null)
  const praiseRef = useRef<HTMLAudioElement>(null)
  const sunRef = useRef<HTMLAudioElement>(null)
  const willEndRef = useRef<HTMLAudioElement>(null)
  const alarmClockRef = useRef<HTMLAudioElement>(null)
  const courseRightRef = useRef<HTMLAudioElement>(null)
  const flowerRef = useRef<HTMLAudioElement>(null)
  const audioRef = useRef<AudioType | null>(null)
  const animRef = useRef<AnimationItem | null>()
  const [state, setState] = useState(false)

  useEffect(() => {
    roomEvent.on('lottie', play)
    audioRef.current = {
      praise: praiseRef.current,
      flower: flowerRef.current,
      sun: sunRef.current,
      willEnd: willEndRef.current,
      alarmClock: alarmClockRef.current,
      courseRight: courseRightRef.current
    }
    return () => {
      roomEvent.removeListener('lottie', play)
    }
  }, [])

  const play = useCallback(async (type: RewardType) => {
    if (lottieRef.current) {
      const res = await axios.get(`https://imgvip.meishubao.com/vip/classroom/2.3.3/production/lottie/${type}.json`)
      animRef.current = lottie.loadAnimation({
        container: lottieRef.current,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: res.data
      })
      setState(true)
      audioRef.current && audioRef.current[type]?.play()
      animRef.current.addEventListener('complete', complete)
    }
  }, [])

  const complete = useCallback(async () => {
    animRef.current && animRef.current.destroy()
    animRef.current = null
    setState(false)
  }, [state])

  return (
    <Container className={`w-screen h-screen flex items-center justify-center flex-col absolute top-0 left-0 z-10 ${state ? 'block' : 'hidden'}`}>
      <div className="w-full h-full bg-[rgba(0,0,0,.5)]" ref={lottieRef}></div>
      <div>
        <audio ref={praiseRef}>
          <source src={praiseMp3} type="audio/mp3" />
        </audio>
        <audio ref={sunRef}>
          <source src={sunMp3} type="audio/mp3" />
        </audio>
        <audio ref={flowerRef}>
          <source src={flowerMp3} type="audio/mp3" />
        </audio>
        <audio ref={willEndRef}>
          <source src={willEndMp3} type="audio/mp3" />
        </audio>
        <audio ref={alarmClockRef}>
          <source src={alarmClockMp3} type="audio/mp3" />
        </audio>
        <audio ref={courseRightRef}>
          <source src={courseRightMp3} type="audio/mp3" />
        </audio>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)``
